export const getItem = (key) => localStorage.getItem(key) ? JSON.parse(localStorage.getItem(key)) : null
export const saveItem = (key, item) => localStorage.setItem(key, JSON.stringify(item))
export const removeItem = (key) => localStorage.removeItem(key)